import { AppState, DateRange, MomentRange, PageProps, Session } from "@declarations"
import DatePicker from "Components/DatePicker/DatePicker"
import TimelineChart from "Components/TimelineChart/TimelineChart"
import { connect } from "react-redux"
import { store } from "Store/store"
import "Components/TimelineChart/TimelineChart.scss"
import { useEffect } from "react"
import { getBounceRatesOverTime } from "Store/Actions/DataActions-VisitorBehavior"
import EmptyState from "Components/EmptyState/EmptyState"
import { setVisitorBehaviorDateRange } from "Store/Actions/DateActions"
import useChartWidth from "Utils/useChartWidth"
import { callCheck } from "Utils/data"

interface Props extends PageProps<typeof mapStateToProps, typeof mapDispatchToProps> {
}

const BounceRatesOverTime = (props: Props) => {

    const { dates, globalView, experiences, updateDates, dataList, demoBrandActive, getDataList, session } = props

    useEffect(() => {

        if (!callCheck(globalView, (session as Session.AuthSession).user.admin, experiences?.length)) return

        getDataList(dates)

    }, [experiences, getDataList, session, demoBrandActive, dates, globalView])

    const width = useChartWidth()

    return (
        <div className="timeline-chart-wrapper" >
            <div className="timeline-chart-header">
                <h3>Bounce rates over time</h3>
                <DatePicker
                    startDate={dates.start}
                    endDate={dates.end}
                    startDateId={"startDateBROT"}
                    endDateId={"endDateBROT"}
                    updateDates={updateDates}
                />
            </div>
            {
                dataList && dataList.length
                    ? <TimelineChart
                        width={width}
                        height={500}
                        startDate={dates.start}
                        endDate={dates.end}
                        data={dataList}
                        legendTitle="Bounce Rate"
                        dataFormat="percent"
                    />
                    : <EmptyState filterableData={true} />
            }
        </div>
    )
}

const mapStateToProps = (state: AppState) => {
    return {
        session: state.session,
        experiences: state.experiences.experienceIdList,
        globalView: state.experiences.globalView,
        demoBrandActive: state.experiences.demoBrandActive,
        dataList: state.data.visitorBehavior.bounceRates.bounceRatesOverTime,
        loadingData: state.loading.visitorBehavior.bounceRates,
        dates: state.dates.visitorBehavior.bounceRatesOverTime
    }
}
const mapDispatchToProps = (dispatch: typeof store.dispatch) => {
    return {
        getDataList: (dates: DateRange) => dispatch(getBounceRatesOverTime(dates)),
        updateDates: (dateRange: MomentRange) => dispatch(setVisitorBehaviorDateRange(dateRange, "bounceRatesOverTime"))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(BounceRatesOverTime)